/* eslint-disable no-unused-vars */

import React, { useContext, useState, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import './style.scss';
import { LoadGif } from '../LoadGif';
import { GetDynamic, GetLogs, isValid } from 'src/services/auth';
import xmlFormatter from 'xml-formatter';

import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { coy } from 'react-syntax-highlighter/dist/esm/styles/prism';

import { ReactComponent as SearchIcon } from 'src/assets/icons/searchFolder.svg';
import { ReactComponent as Check } from 'src/assets/icons/check.svg';
import { ReactComponent as End } from 'src/assets/icons/end.svg';
import { ReactComponent as ArrowDown } from 'src/assets/icons/downArrow.svg';
import CustomInput from '../customInput';

export default function Logs({ Disabled }) {
  const [load, setLoad] = useState(false);

  const [logData, setLogData] = useState([]);
  const [flterData, setFilterData] = useState([]);
  const [logSelect, setLogSelect] = useState(0);
  const [selected, setSelected] = useState({});

  const [showPopup, setShowPopup] = useState('');
  const hoje = new Date().toISOString().slice(0, 10);
  const [inicio, setInicio] = useState(hoje);
  const [fim, setFim] = useState(hoje);
  const [limit, setLimit] = useState(20);
  const [page, setPage] = useState(1);

  const [busca, setBusca] = useState('');
  const [id, setId] = useState('');
  const [user, setUser] = useState('');
  const [idOptions, setIdOptions] = useState([]);
  const [userOptions, setUserOptions] = useState([]);

  const [copyShow1, setCopyShow1] = useState(false);
  const [copyShow2, setCopyShow2] = useState(false);

  const customTheme = {
    main: 'color: #007e98; background:#f9f9f9;', // Fundo
    key: 'color: #004c5b;', // Chaves
    string: 'color: #c96800;', // Strings
    value: 'color: #b80900;', // Valores
    boolean: 'color: #99008c;', // Booleanos
    number: 'color: #4d0099;', // Números
  };

  function handleSelect(id) {
    setLogSelect(id);
    setSelected(logData.filter((item) => item.id === id)[0]);
  }

  function HandleConsulta() {
    setLoad(true);
    if (
      !isValid(inicio) ||
      !isValid(fim) ||
      !isValid(limit) ||
      !isValid(page)
    ) {
      setLoad(false);
      return;
    }

    GetLogs(
      'Get',
      `soap/logs?dataInicio=${inicio}&dataFim=${fim}&page=${page}&limit=${limit}`
    )
      .then((res) => {
        const key = Object.keys(res)[0];
        const logs = res[key]?.data?.logs || [];
        setLogData(logs);
      })
      .finally(() => {
        setShowPopup('');
        setLoad(false);
      });
  }

  useEffect(() => {
    const buscaValida = busca.trim() !== '';
    const idValido = id.trim() !== '';
    const userValido = user.trim() !== '';

    if (buscaValida || idValido || userValido) {
      const filtro = logData.filter((item) => {
        const texto = JSON.stringify(item).toLowerCase();
        const buscaMatch = buscaValida
          ? texto.includes(busca.toLowerCase())
          : true;
        const idMatch = idValido ? texto.includes(id.toLowerCase()) : true;

        const userMatch = userValido
          ? item.request_xml
              ?.toLowerCase()
              .includes(`<user>${user.toLowerCase()}</user>`)
          : true;

        return buscaMatch && idMatch && userMatch;
      });

      setFilterData(filtro);
    } else {
      setFilterData(logData);
    }

    const options = logData
      .map((item) => item.identificador)
      .filter((v, i, a) => v && a.indexOf(v) === i);

    setIdOptions(options);

    const usersUnicos = logData
      .map((log) => {
        const match = log.request_xml?.match(/<user>(.*?)<\/user>/);
        return match?.[1];
      })
      .filter((user, index, self) => user && self.indexOf(user) === index);

    setUserOptions(usersUnicos);
  }, [busca, id, user, logData]);

  return (
    <div className={`Logs ${Disabled && 'hide'}`}>
      {load && <LoadGif />}
      {showPopup === 'consulta' && (
        <div className="modal consulta absoluteCenter">
          <h2> Filtros </h2>
          <div className="inputs">
            <CustomInput
              Type={'date'}
              PlaceHolder={'Inicio'}
              Color={'#0fa697'}
              OnChange={(e) => {
                setInicio(e.target.value);
              }}
              Size={'wFull'}
              DefaultValue={inicio}
            />
            <CustomInput
              Type={'date'}
              PlaceHolder={'Fim'}
              Color={'#0fa697'}
              OnChange={(e) => {
                setFim(e.target.value);
              }}
              Size={'wFull'}
              DefaultValue={fim}
            />

            <CustomInput
              OnChange={(e) => setLimit(e.target.value)}
              Type="number"
              PlaceHolder="Limite"
              DefaultValue={Number(limit)}
            />
            <CustomInput
              OnChange={(e) => setPage(e.target.value)}
              Type="number"
              PlaceHolder="Pagina"
              DefaultValue={page}
            />

            <span className="consultaControls">
              <button
                className="mainButton red"
                onClick={() => setShowPopup('')}
              >
                <End />
                Cancelar
              </button>
              <button
                className="mainButton turquoise"
                onClick={() => HandleConsulta()}
              >
                <Check />
                Consultar
              </button>
            </span>
          </div>
        </div>
      )}

      <aside>
        <button onClick={() => setShowPopup('consulta')} className="consulta">
          <SearchIcon /> Consultar
        </button>

        <div className="search">
          <input
            onChange={(e) => setBusca(e.target.value)}
            value={busca}
            type="text"
            placeholder="Pesquisar"
          />
          <button className="clean" onClick={() => setBusca('')}>
            <End />
          </button>
        </div>

        <div className="search">
          <select onChange={(e) => setId(e.target.value)} value={id}>
            <option value="">Escolher Id</option>
            {idOptions.map((value, index) => (
              <option key={index} value={value}>
                {value}
              </option>
            ))}
          </select>
          <div className="clean" style={{ pointerEvents: 'none' }}>
            <ArrowDown />
          </div>
        </div>

        <div className="search">
          <select onChange={(e) => setUser(e.target.value)} value={user}>
            <option value="">Escolher Usuario</option>
            {userOptions.map((value, index) => (
              <option key={index} value={value}>
                {value}
              </option>
            ))}
          </select>
          <div className="clean" style={{ pointerEvents: 'none' }}>
            <ArrowDown />
          </div>
        </div>

        <div className="scroll">
          {flterData?.map((item, index) => (
            <button
              className={logSelect === item.id && 'active'}
              key={index}
              onClick={() => handleSelect(item.id)}
            >
              <span
                className="dot"
                style={{
                  backgroundColor:
                    item.status_code === 200 || item.has_error
                      ? 'green'
                      : 'red',
                }}
              />
              <p>{item.id}</p>
            </button>
          ))}
        </div>
      </aside>

      <aside>
        {logSelect != 0 && (
          <div>
            <div className="info">
              <p>
                Id: <span>{selected.id} </span>
              </p>

              <p>
                Status:{' '}
                <span
                  style={{
                    paddingBottom: '0.1rem',
                    borderBottom: `3px solid ${selected.status_code === 200 || selected.has_error ? 'green' : 'red'}`,
                  }}
                >
                  {selected.status_code}{' '}
                </span>
              </p>

              <p>
                Id Empresa: <span>{selected.identificador} </span>
              </p>

              <p>
                Duração:{' '}
                <span>
                  {Math.floor(selected.response_time_seconds / 60) > 0 &&
                    Math.floor(selected.response_time_seconds / 60)}
                  {Math.floor(selected.response_time_seconds / 60) > 0 && 'min'}{' '}
                  {Math.floor(selected.response_time_seconds % 60)}s
                </span>
              </p>

              <p>
                Criado Em:{' '}
                <span>
                  {new Date(selected.created_at).toLocaleString('pt-BR', {
                    hour: '2-digit',
                    minute: '2-digit',
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric',
                  })}
                  h
                </span>
              </p>
            </div>

            <p>
              Url: <span> {selected.request_url} </span>
            </p>

            <p className="request">
              Request <span>(XML)</span>
            </p>
            <button
              className="copy"
              onClick={() => {
                navigator.clipboard.writeText(selected.request_xml);
                setCopyShow1(true);
                setTimeout(() => {
                  setCopyShow1(false);
                }, 1500);
              }}
            >
              📋 <label>Copiar conteúdo</label>
              <span className={copyShow1 ? 'show' : 'hide'}> Copiado! </span>
            </button>
            <div className="snnipet">
              <SyntaxHighlighter
                language="xml"
                style={coy}
                wrapLongLines={true}
                customStyle={{
                  backgroundColor: '#f4f4f4',
                  padding: '1rem',
                  borderRadius: '8px',
                }}
              >
                {xmlFormatter(selected.request_xml || '', {
                  indentation: '  ',
                  collapseContent: true,
                })}
              </SyntaxHighlighter>
            </div>

            <p className="request">
              Response <span>(XML)</span>
            </p>
            <button
              className="copy"
              onClick={() => {
                navigator.clipboard.writeText(selected.response_xml);
                setCopyShow2(true);
                setTimeout(() => {
                  setCopyShow2(false);
                }, 1500);
              }}
            >
              📋 <label>Copiar conteúdo</label>
              <span className={copyShow2 ? 'show' : 'hide'}> Copiado! </span>
            </button>
            <div className="snnipet">
              <SyntaxHighlighter
                language="xml"
                style={coy}
                wrapLongLines={true}
                customStyle={{
                  backgroundColor: '#f4f4f4',
                  padding: '1rem 1rem 0',
                  borderRadius: '8px',
                }}
              >
                {xmlFormatter(selected.response_xml || '', {
                  indentation: '  ',
                  collapseContent: true,
                })}
              </SyntaxHighlighter>
            </div>
          </div>
        )}
      </aside>
    </div>
  );
}

Logs.propTypes = {
  Disabled: PropTypes.bool,
};
